export default __webpack_public_path__ + "static/media/plant-outline-white.33f81667.svg";